import { gsap } from 'gsap';

import { LazySelectable, mergeDeep } from '@sg-core/resources/assets/js/utils';

import { Animate, AnimateOptions } from './animate';
import { STATES } from './states';

export interface AnimateRevealOptions extends AnimateOptions {
  gsapOptions?: Record<string, unknown>;
  [key: string]: unknown;
}

export class AnimateReveal extends Animate {
  declare protected options: AnimateRevealOptions;

  constructor(element: LazySelectable, options: AnimateRevealOptions = {}) {
    super(element, options);
  }

  register() {
    gsap.to(
      this.el,
      mergeDeep(
        {
          scrollTrigger: {
            trigger: this.el,
            start: '0% top',
            onEnter: () => {
              this.reveal();
            },
          },
        },
        this.options.gsapOptions ?? {},
      ),
    );
  }

  reveal() {
    this.el.classList.add(STATES.REVEALED);
  }
}
